fx.ns("models", class FacebookAlbumModel extends fx.Model {

	constructor(data)
	{
		super(data);
	}

	get defaults()
	{
		return {
			// selected: false
		}
	}

	get isLoaded()
	{
		return this.isLoaded;
	}

	set isLoaded(val)
	{
		this.isLoaded = val;
		return this.isLoaded;
	}

	setActiv()
	{
		for (let i = 0; i < this.parentModel.length; i++)
		{
			this.parentModel.getItemAt(i).isActive = false;
		}

		this.isActive = true;

		if(window.fx.browser.isMobile || window.fx.browser.isTablet)
			this.event("show-facebook-photos");
	}

});